<template>
    <div class="clearfix pb-3 px-0 ml-0 col-sm-12"> <!-- Abdullah removed class company-form-container rounded mt-4 and added px-0  -->

        <!-- <div class="clearfix row py-2 mb-2 border-bottom">
            <div class="col-sm-6 px-3 company-form-box-title">Overview</div>
            <template v-if="this.$acl['company/info'] == 2"><div class="col-sm-6 pl-3 cursor-pointer text-right company-form-box-title" v-if="readonly" @click="trz_display()"><button class="edit-icon"><i class="fa fa-pencil-alt"></i></button></div></template>
        </div> -->

        <!-- Abdullah added this block of code -->
        <div class="row no-margin mt-4" v-if="readonly">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4>Overview <template v-if="this.$acl['company/info'] == 2"><button class="edit-icon" v-if="readonly" @click="trz_display('company-overview-form')"><i class="fa fa-pencil-alt"></i></button></template></h4>
                </div>
                <div class="ibox-content">
                    <div class="row front-public-info-wrapper">
                        <div class="col-md-8 p-0 d-flex align-items-center">
                            <b-avatar class="m-0" variant="light" rounded button size="100%" :src="logoUrl"></b-avatar>
                            <div class="employee-inner-content pl-4">
                                <dl class="row py-3 px-0 public-info-last company-public-info border-0">
                                    <dt class="col-sm-5 text company_name">Company Name:</dt>
                                    <dd class="col-sm-7 value company_value">{{fdata.name}}</dd>

                                    <dt class="col-sm-5 text">Contact Person:</dt>
                                    <dd class="col-sm-7 value">{{ fdata.contact_person }}</dd>

                                    <dt class="col-sm-5 text">Contact Person Designation:</dt>
                                    <dd class="col-sm-7 value">{{fdata.contact_person_designation}}</dd>

                                    <dt class="col-sm-5 text">Email Address:</dt>
                                    <dd class="col-sm-7 value">{{fdata.email}}</dd>

                                    <dt class="col-sm-5 text">Contact Number:</dt>
                                    <dd class="col-sm-7 value">+880 {{fdata.phone}}</dd>
                                </dl>
                            </div>
                        </div>
                        <div class="col-md-4  p-0">
                            <dl class="row py-3 px-0 public-info-last company-public-info">
                                <dt class="col-sm-5 text">Company Address:</dt>
                                <dd class="col-sm-7 value">{{fdata.address}}</dd>

                                <dt class="col-sm-5 text">Zip Code:</dt>
                                <dd class="col-sm-7 value">{{ fdata.zip }}</dd>

                                <dt class="col-sm-5 text">City:</dt>
                                <dd class="col-sm-7 value">{{fdata.city}}</dd>

                                <dt class="col-sm-5 text">Country:</dt>
                                <dd class="col-sm-7 value">{{fdata.country}}</dd>

                                <dt class="col-sm-5 text">Company Website:</dt>
                                <dd class="col-sm-7 value">{{fdata.website}}</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- abdullah added upto this  -->


        <div :class="this.trz_display_form">
            <template v-if="this.flg == 1">  <!-- abdullah added this template here  -->
                <b-form @submit.stop.prevent="onSubmit" class=""> <!-- abdullah removed class mt-3  -->

                    <!-- Abdullah added this block of code  -->
                    <div class="clearfix row form-btn-container rounded mb-5 mx-3">
                        <div class="col-md-4 pl-0">
                            <b-button class="custom-wizard-btn" :href="$api_url + '/company'"><b-icon icon="chevron-left" rotate="0" class="mr-2" scale="1"></b-icon> Back to Agent Accrual</b-button>
                        </div>
                        <div class="col-md-4 text-center custom-wizard-title">Overview</div>
                        <div class="col-md-4 pr-0 text-right"><b-button v-if="new_capability && readonly == false" type="submit" @click="set_go_next()" variant="primary" class="">Save & Go Next <b-icon icon="chevron-right" rotate="0" class="mt-n1" scale="1"></b-icon></b-button></div>
                    </div>
                    <!-- upto this  -->

                    <b-overlay :show="showoverlay" rounded="sm">
                    <div class="clearfix">
                        <div class="col-md-6 float-left px-3">

                            <b-form-group id="name-group" label="Company Name" class="required-field" label-for="name">
                                <b-form-input id="name" :disabled="readonly" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Company Name"></b-form-input>
                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group id="contact_person_designation-group" label="Contact Person's Designation" label-for="contact_person_designation">
                                <b-form-input  :disabled="readonly" id="contact_person_designation" name="contact_person_designation" v-model="fdata.contact_person_designation"></b-form-input>
                            </b-form-group>

                            <b-form-group id="phone-group" label="Contact Number" class="required-field" label-for="phone">
                                <b-input-group prepend="+880">
                                    <b-form-input :disabled="readonly" id="phone" name="phone" v-model="fdata.phone" v-validate="{ required: true, min: 10 , max:10 }" :state="validateState('phone')" aria-describedby="phone-feedback" data-vv-as="Contact Number"></b-form-input>
                                    <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>

                            <div class="row">

                            <div class="col-sm-6">
                                <b-form-group id="city-group" label="City" class="required-field custom-select-arrow" label-for="city">
                                    <b-form-select :disabled="readonly" id="city" name="city" v-model="fdata.city" v-validate="{ required: true }" :options="city" :state="validateState('city')" aria-describedby="city-feedback" data-vv-as="City"></b-form-select>
                                    <b-form-invalid-feedback id="city-feedback">{{ veeErrors.first('city') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-sm-6">
                                <b-form-group id="zip-group" label="Zip Code" class="required-field" label-for="zip">
                                    <b-form-input :disabled="readonly" id="zip" name="zip" v-model="fdata.zip" v-validate="{required: true, min: 4 }" :state="validateState('zip')" aria-describedby="zip-feedback" data-vv-as="Zip Code"></b-form-input>
                                    <b-form-invalid-feedback id="zip-feedback">{{ veeErrors.first('zip') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                        </div>
                            <b-form-group id="country-group" label="Country" class="required-field custom-select-arrow disabled-input" label-for="country">
                                <b-form-select :disabled="readonly" id="country" name="country" v-model="fdata.country" v-validate="{ required: true }" :options="countries" :state="validateState('country')" aria-describedby="country-feedback" data-vv-as="Country"></b-form-select>
                                <b-form-invalid-feedback id="country-feedback">{{ veeErrors.first('country') }}</b-form-invalid-feedback>

                            </b-form-group>



                            <div id="company_logo-group" role="group" class="form-group">
                                <label id="company_logo-group__BV_label_" for="company_logo" class="d-block">Company Logo</label>
                                <div class="bv-no-focus-ring cmpny-logo-uploader">
                                    <my-upload :disabled="readonly" field="img"
                                        @crop-success="cropSuccess"
                                        v-model="showLogoUploader"
                                        lang-type="en"
                                        :width="400"
                                        :height="400"
                                        img-format="jpeg"></my-upload>

                                    <img :src="logoUrl"  @click="toggleLogoUploader" style="cursor: pointer;">
                                    <div @click="toggleLogoUploader" class="cmpny-logo-overlay">Upload</div>
                                </div>
                            </div>
                        </div>
                        <!-- for company website validation :state="validateState('website')" -->
                        <div class="col-md-6 float-right px-3">

                            <b-form-group id="contact_person-group" label="Contact Person" label-for="contact_person">
                                <b-form-input :disabled="readonly" id="contact_person" name="contact_person" v-model="fdata.contact_person"></b-form-input>
                            </b-form-group>

                            <b-form-group id="email-group" label="Email" class="required-field" label-for="email">
                                <b-form-input :disabled="readonly" id="email" name="email" type="email" v-model="fdata.email" v-validate="{ required: true, email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                                <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group id="address-group" label="Company Address" class="required-field" label-for="address">
                                <b-form-textarea :disabled="readonly" id="address" class="trz_address" name="address" rows="4" max-rows="5" no-resize v-model="fdata.address" v-validate="{required: true, min: 3 }" :state="validateState('address')" aria-describedby="address-feedback" data-vv-as="Company Address"></b-form-textarea>
                                <b-form-invalid-feedback id="address-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
                            </b-form-group>


                            <b-form-group id="website-group" label="Company Website" label-for="website">
                                <b-form-input :disabled="readonly" id="website" name="website" v-model="fdata.website"></b-form-input>
                            </b-form-group>




                        </div>

                    </div>

                        <div class="col-sm-12 px-3 text-center" v-if="$acl['company/tax_info'] == 2">
                            <!---->
                            <!--<b-button v-if="new_capability" type="submit" @click="set_go_next()" variant="primary" class="float-right mt-3">Save</b-button>-->



                            <!-- AbdullahALC Chnaged, added class d-none and chnaged varient to primary -->
                            <template v-if="this.flg == 1">
                                <b-button v-if="new_capability && readonly == false" type="submit" @click="set_go_next()" variant="primary" class="settings_new_button d-none">Save & Go Next</b-button>
                                <b-button v-if="new_capability && readonly == false" type="submit" @click="setfinish()" variant="primary" class="settings_new_button">Finish</b-button>
                            </template>
                            <template v-else>
                                <b-button v-if="new_capability && readonly == false" type="submit" @click="disable_set_go_next()" variant="submit" class="settings_new_button">Save</b-button>
                            </template>
                        </div>


                    </b-overlay>
                </b-form>
            </template>

            <!-- Abdullah added this block of code here -->
            <template v-else>
                <b-modal id="company-overview-form" title="Edit Company Overview Details" dialog-class="w-1000"  hide-footer @hidden="onHidden">
                    <b-form @submit.stop.prevent="onSubmit" class="mt-3">
                        <b-overlay :show="showoverlay" rounded="sm">
                        <div class="clearfix">
                            <div class="col-md-6 float-left px-3">

                                <b-form-group id="name-group" label="Company Name" class="required-field" label-for="name">
                                    <b-form-input id="name" :disabled="readonly" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Company Name"></b-form-input>
                                    <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                </b-form-group>

                                <b-form-group id="contact_person_designation-group" label="Contact Person Designation" label-for="contact_person_designation">
                                    <b-form-input  :disabled="readonly" id="contact_person_designation" name="contact_person_designation" v-model="fdata.contact_person_designation"></b-form-input>
                                </b-form-group>

                                <b-form-group id="phone-group" label="Contact Number" class="required-field" label-for="phone">
                                    <b-input-group prepend="+880">
                                        <b-form-input :disabled="readonly" id="phone" name="phone" v-model="fdata.phone" v-validate="{ required: true, min: 10 , max:10 }" :state="validateState('phone')" aria-describedby="phone-feedback" data-vv-as="Contact Number"></b-form-input>
                                        <b-form-invalid-feedback id="phone-feedback">{{ veeErrors.first('phone') }}</b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>

                                <div class="row">

                                    <div class="col-sm-6">
                                        <b-form-group id="city-group" label="City" class="required-field custom-select-arrow" label-for="city">
                                            <b-form-select :disabled="readonly" id="city" name="city" v-model="fdata.city" v-validate="{ required: true }" :options="city" :state="validateState('city')" aria-describedby="city-feedback" data-vv-as="City"></b-form-select>
                                            <b-form-invalid-feedback id="city-feedback">{{ veeErrors.first('city') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="col-sm-6">
                                        <b-form-group id="zip-group" label="Zip Code" class="required-field" label-for="zip">
                                            <b-form-input :disabled="readonly" id="zip" name="zip" v-model="fdata.zip" v-validate="{required: true, min: 4 }" :state="validateState('zip')" aria-describedby="zip-feedback" data-vv-as="Zip Code"></b-form-input>
                                            <b-form-invalid-feedback id="zip-feedback">{{ veeErrors.first('zip') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                </div>
                                <b-form-group id="country-group" label="Country" class="required-field custom-select-arrow disabled-input" label-for="country">
                                    <b-form-select :disabled="readonly" id="country" name="country" v-model="fdata.country" v-validate="{ required: true }" :options="countries" :state="validateState('country')" aria-describedby="country-feedback" data-vv-as="Country"></b-form-select>
                                    <b-form-invalid-feedback id="country-feedback">{{ veeErrors.first('country') }}</b-form-invalid-feedback>

                                </b-form-group>



                                <div id="company_logo-group" role="group" class="form-group">
                                    <label id="company_logo-group__BV_label_" for="company_logo" class="d-block">Company Logo</label>
                                    <div class="bv-no-focus-ring cmpny-logo-uploader">
                                        <my-upload :disabled="readonly" field="img"
                                            @crop-success="cropSuccess"
                                            v-model="showLogoUploader"
                                            lang-type="en"
                                            :width="400"
                                            :height="400"
                                            img-format="jpeg"></my-upload>

                                        <img :src="logoUrl"  @click="toggleLogoUploader" style="cursor: pointer;">
                                        <div @click="toggleLogoUploader" class="cmpny-logo-overlay">Upload</div>
                                    </div>
                                </div>
                            </div>
                            <!-- for company website validation :state="validateState('website')" -->
                            <div class="col-md-6 float-right px-3">

                                <b-form-group id="contact_person-group" label="Contact Person" label-for="contact_person">
                                    <b-form-input :disabled="readonly" id="contact_person" name="contact_person" v-model="fdata.contact_person"></b-form-input>
                                </b-form-group>

                                <b-form-group id="email-group" label="Email" class="required-field" label-for="email">
                                    <b-form-input :disabled="readonly" id="email" name="email" type="email" v-model="fdata.email" v-validate="{ required: true, email:true}" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                                    <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                                </b-form-group>


                                <b-form-group id="address-group" label="Company Address" class="required-field" label-for="address">
                                    <b-form-textarea :disabled="readonly" id="address" class="trz_address" name="address" rows="4" max-rows="5" no-resize v-model="fdata.address" v-validate="{required: true, min: 3 }" :state="validateState('address')" aria-describedby="address-feedback" data-vv-as="Company Address"></b-form-textarea>
                                    <b-form-invalid-feedback id="address-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
                                </b-form-group>


                                <b-form-group id="website-group" label="Company Website" label-for="website">
                                    <b-form-input :disabled="readonly" id="website" name="website" v-model="fdata.website"></b-form-input>
                                </b-form-group>




                            </div>

                        </div>

                            <div class="col-sm-12 px-3 text-center" v-if="$acl['company/tax_info'] == 2">
                                <!---->
                                <!--<b-button v-if="new_capability" type="submit" @click="set_go_next()" variant="primary" class="float-right mt-3">Save</b-button>-->



                                <template v-if="this.flg == 1">
                                    <b-button v-if="new_capability && readonly == false" type="submit" @click="set_go_next()" variant="primary" class="settings_new_button">Save & Go Next</b-button>
                                    <b-button v-if="new_capability && readonly == false" type="submit" @click="setfinish()" variant="primary" class="settings_new_button">Finish</b-button>
                                </template>
                                <template v-else>
                                    <b-button v-if="new_capability && readonly == false" type="submit" @click="disable_set_go_next()" variant="primary" class="settings_new_button">Update</b-button>
                                </template>
                            </div>


                        </b-overlay>
                    </b-form>
                </b-modal>
                <company-taxinfo :pageurl="this.$api_url" :check_ce="1" :ce_flg="this.ce" v-on:childToParent="getTaxInfoFlg"></company-taxinfo>
            </template>
            <!-- Abdullah added this block of code here upto this.-->
        </div>
    </div>
</template>
<script>
    import myUpload from 'vue-image-crop-upload';
    export default{
        mounted() {

            if(this.flg == 1)
                this.readonly = false;
        },
        props: ['flg' , 'ce_flg' , 'check_ce'],
        components: {'my-upload': myUpload, },
        data(){

            return {
                cu : window.location.href,
                ce : false,
                go_next : false,

                company_id : 0,

                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : false,
                movenext : false,
                finish : false,


                errormsg : [],
                fdata : {city: null, country: 'Bangladesh'},
                file : null,
                new_capability : true,
                city : [
                    { value: null, text: "Select..." },
                    { value: "Dhaka", text: "Dhaka" },
                    { value: "Chattogram", text: "Chattogram" },
                    { value: "Khulna", text: "Khulna" },
                    { value: "Rajshahi", text: "Rajshahi" },
                    { value: "Rangpur", text: "Rangpur" },
                    { value: "Sylhet", text: "Sylhet" },
                    { value: "Barishal", text: "Barishal" },
                    { value: "Gazipur", text: "Gazipur" },
                    { value: "Bogura", text: "Bogura" },
                    { value: "Cumilla", text: "Cumilla" },
                    { value: "Mymensingh", text: "Mymensingh" },
                ],

                countries : [{ value: "Bangladesh", text: "Bangladesh" }],

                //logoUrl : this.$api_url + '/images/company/' + 'demo.jpg',
                logoUrl : '',
                logoUploaded: false,
                showLogoUploader: false,

                trz_display_form : '',
                taxinfo_flg:0,
                readonly : true,


            }
        },
        methods:{

            // Abdullah added this function
            getTaxInfoFlg (value) {
                this.taxinfo_flg = value.flg;
                this.successmsg = value.successmsg;
                this.warningmsg = value.warningmsg;
                this.dangermsg = value.dangermsg;
            },
            toggleLogoUploader() {
				this.showLogoUploader = !this.showLogoUploader;
			},
            trz_display: function(form_name)
            {
                this.trz_display_form = '';
                // this.readonly = !this.readonly;
                this.readonly = false; // keep readonly false while modal is open
                this.$bvModal.show(form_name);
            },
            set_go_next(x){
                this.go_next = true;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            disable_set_go_next(){
                this.go_next = false;
            },
            setfinish(x){
                this.finish = true;
                if(x == 1)
                    this.showMessage();
            },
			cropSuccess(imgDataUrl, field){

				this.logoUrl = imgDataUrl;
                this.logoUploaded = true;
			},

            // Abdullah added thisfunction here
            // AbdullahFixed chnaged helpers. was  this.readonly = !this.readonly;
            // FIX 2 & 3: set readonly back to true and refresh data so overview reappears
            onHidden: function()
            {
                // this.readonly = false;
                this.readonly = true;
                this.editCompany();
            },
            showMessage: function()
            {
                let tmp_flg = 0;
                if(this.company_id > 0)tmp_flg = 1;
                let childdata = {company_id:this.company_id , flg:tmp_flg , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg,  move_next:this.go_next , finish:this.finish};
                this.$emit('childToParent', childdata);
            },
            editCompany:function()
            {
                if(!this.checkNet()) return false;
                this.successmsg = null;
                this.errormsg = [];
                this.new_capability = true;
                this.go_next = false;
                axios.get(this.$api_url+'/company/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    if(response.data.id > 0)
                    {
                        this.fdata = response.data;
                        this.logoUrl = this.$api_url + '/images/company/' + response.data.logo;

                        if(this.fdata.website == 'null') this.fdata.website = '';
                        if(this.fdata.contact_person == 'null') this.fdata.contact_person = '';
                        if(this.fdata.contact_person_designation == 'null') this.fdata.contact_person_designation = '';


                        this.company_id =  response.data.id;
                        this.showMessage();
                    }
                    else
                    {
                        this.fdata = {city:null, country: 'Bangladesh'};
                        this.logoUrl = this.$api_url + '/images/company/' + 'demo.jpg',
                        this.company_id =  0;
                        this.showMessage();
                    }
                    this.$validator.reset();
                }.bind(this)).catch(function (error){this.serverError(error);});


            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.successmsg = false;
                this.warningmsg = false;
                this.dangermsg = false;

                //this.showMessage();

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    this.showoverlay = true;
                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData();

                    if(this.logoUploaded)
                        formData.append('company_logo', this.logoUrl);

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/company/save?flg=0', formData, config)
                                .then(function (response)
                                {
                                    this.showoverlay = false;
                                    this.fdata = response.data;
                                    if(this.fdata.website == 'null') this.fdata.website = '';
                                    if(this.fdata.contact_person == 'null') this.fdata.contact_person = '';
                                    if(this.fdata.contact_person_designation == 'null') this.fdata.contact_person_designation = '';

                                    //this.successmsg = 'Saved!';
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    this.$validator.reset();

                                    this.company_id =  response.data.id;
                                    //currentObj.go_next = true;
                                    this.showMessage();

                                    this.readonly = true;
                                    this.ce = true;


                                }.bind(this))
                                .catch(function (error)
                                {

                                    currentObj.showoverlay = false;
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                    for (var data in currentObj.errormsg)
                                    {
                                        var msg = currentObj.errormsg[data];
                                        currentObj.$bvToast.toast(msg, {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                                        currentObj.$validator.reset();
                                    }
                                });
                });
            },
        },
        created: function(){
            this.editCompany();
        }
    }
</script>
<style>
    .trz_address{height: 121px !important;}
</style>
